import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import MainLayout from '@/components/Layout/MainLayout';
import ChatPage from '@/components/pages/ChatPage';
import ConfigPage from '@/components/pages/ConfigPage';
import LoginPage from '@/components/pages/LoginPage';
import { useAuthStore } from '@/stores/useAuthStore';
import { useEffect } from 'react';

const ProtectedLayout: React.FC = () => {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const loading = useAuthStore((s) => s.loading);
  const init = useAuthStore((s) => s.init);

  useEffect(() => {
    init();
  }, [init]);

  if (!token) return <Navigate to="/login" replace />;
  if (!user && loading) {
    return <Box sx={{ width: '100vw', height: '100vh', display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;
  }
  return <MainLayout />;
};

/**
 * 应用根组件，定义全局路由和布局。
 */
const App: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedLayout />}>
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/config" element={<ConfigPage />} />
          <Route path="*" element={<ChatPage />} />
        </Route>
      </Routes>
    </Box>
  );
};

export default App;
